import {
  ContenidoState,
  getInitialContenidoState,
} from 'src/app/store/state/content.state';
import {
  initialMaestrosState,
  MaestrosState,
} from 'src/app/store/state/maestros.state';
import { getInitialPagoState, PagoState } from 'src/app/store/state/pago.state';

export interface AppState {
  maestros: MaestrosState;
  pago: PagoState;
  contenido: ContenidoState;
}

export const initialState: AppState = {
  maestros: initialMaestrosState,
  pago: getInitialPagoState(),
  contenido: getInitialContenidoState(),
};

export function getInitialState(): AppState {
  return initialState;
}
